import { createSlice } from "@reduxjs/toolkit";
import type {
  CurrentUser,
  PaginatedUserLimitedListList,
  UserGroup,
  UserProfile,
} from "../../app/generated-axios-client";
import type { PayloadAction } from "@reduxjs/toolkit";

export type ChangePasswordStatus = "idle" | "loading" | "succeeded" | "failed";

export interface UserState {
  user?: CurrentUser;
  list: PaginatedUserLimitedListList;
  viewedProfile: UserProfile | null;
  groups: UserGroup[];
  updateProfileLoading: boolean;
  changePasswordStatus: ChangePasswordStatus;
}

const initialState: UserState = {
  list: {
    "pagination": {
      "total_items": 0,
      "total_pages": 0,
      "current_page": 0,
      "per_page": 0,
    },
    "results": [],
  },
  viewedProfile: null,
  groups: [],
  updateProfileLoading: false,
  changePasswordStatus: "idle",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    getUser: (state, action: PayloadAction<CurrentUser>) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = undefined;
    },
    getUserList: (state, action: PayloadAction<PaginatedUserLimitedListList>) => {
      state.list = action.payload;
    },
    storeViewedProfile: (state, action: PayloadAction<UserProfile>) => {
      state.viewedProfile = action.payload;
    },
    clearViewedProfile: (state) => {
      state.viewedProfile = null;
    },
    storeGroups: (state, action: PayloadAction<UserGroup[]>) => {
      state.groups = action.payload;
    },
    updateProfile: (state, _action: PayloadAction<{ profileId: string; payload: Partial<UserProfile> }>) => {
      state.updateProfileLoading = true;
    },
    setUpdateProfileLoading: (state, action: PayloadAction<boolean>) => {
      state.updateProfileLoading = action.payload;
    },
    changePassword: (_state, _action: PayloadAction<{ profileId: string; oldPassword: string; newPassword: string }>) => {},
    setChangePasswordStatus: (state, action: PayloadAction<ChangePasswordStatus>) => {
      state.changePasswordStatus = action.payload;
    },
  },
});

export const userActions = userSlice.actions;
export const userSliceReducer = userSlice.reducer;
export default userSliceReducer;
